import { Component, forwardRef, Input, OnChanges, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

export interface Fruit {
  name: string;
}

@Component({
  selector: 'chips-filter',
  templateUrl: 'chips-filter.component.html',
  styleUrl: 'chips-filter.component.scss',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule,
    MatSelectModule,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChipsFilterComponent),
      multi: true,
    },
  ],
})
export class ChipsFilterComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() public items: { label: string; value: string; color?: string }[] = [];
  @Input() public label = '';
  @Input() public placeholder = '';
  @Input() disabled = false;

  public control = new FormControl<string[]>([]);
  public filteredItems!: typeof this.items;
  public MAX_DISPLAY_CHIPS = 2;

  private onChange: (value: string[]) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnInit() {
    this.control.valueChanges.subscribe(value => {
      this.onChange(value || []);
    });
  }

  ngOnChanges() {
    if (this.disabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }
    this.filteredItems = [...(this.items || [])];
  }

  public findItem(value: string) {
    return this.items.find(item => item.value === value);
  }

  public remove(value: string) {
    const updatedValue = this.control.value?.filter(item => item !== value) || [];
    this.control.setValue(updatedValue);
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this.control.setValue(value, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
